import { IconArrowRight } from '@tabler/icons-react'
import { useTranslation } from 'react-i18next'

import { Button } from 'src/components/Button/Button'

import styles from './SkipLinks.module.scss'

export interface SkipLink {
  href: string
  translationKey: string
}

interface SkipLinksProps {
  links?: SkipLink[]
}

export const SkipLinks = ({ links: providedLinks }: SkipLinksProps) => {
  const { t } = useTranslation()

  const links: SkipLink[] = [
    {
      href: '#navigation',
      translationKey: 'navigation',
    },
    // If no custom links have been provided by the page type, "skip to content" is the generic fallback.
    ...(providedLinks || [
      {
        href: '#content',
        translationKey: 'content',
      },
    ]),
    {
      href: '#footer',
      translationKey: 'footer',
    },
  ]

  return (
    <ul>
      {links.map((link) => (
        <li key={`skip-link-${link.href}`}>
          <Button href={link.href} variant="secondary" className={styles.link} endIcon={<IconArrowRight />}>
            {t(`skipLinks.${link.translationKey}`)}
          </Button>
        </li>
      ))}
    </ul>
  )
}
